import { useEffect, useState } from "react";
import { ActionButton } from "../../../common/Buttons/Buttons";
import { Header } from "../../../common/Header/Header.jsx";
import caseOpenOperations from "../../../../images/caseOpenOperations.svg";
import craneIndicator from "../../../../images/craneIndicator.svg";
import craneCostIndicator from "../../../../images/craneCostIndicator.svg";
import operatorStats from "../../../../images/operatorStats.svg";
import bikeOrange from "../../../../images/bikeOrange.svg";
import toedOperator from "../../../../images/toedOperator.svg";
import fixOperator from "../../../../images/fixOperator.svg";
import finishedOperator from "../../../../images/finishedOperator.svg";
import locations from "../../../../images/locations.svg";
import * as schemas from "../../../../assets/schemas/schemas.js";
import { OperationCard } from "../../../common/Cards/Cards";
import "./Operations.scss";
import { statisticsService } from "../../../../services/StatisticsService.js";
import { notify } from "../../../../assets/helpers/toast.js";
import moment from "moment";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { DailyReportModal } from "../../../common/Modals/Modals.jsx";
import { LoadSpinner } from "../../../common/LoadSpinner/LoadSpinner.jsx";
import authService from "../../../../services/authService.js";
import { capitalize } from "@material-ui/core";
import { DailyReportTableHeader } from "../../../../assets/helpers/tables.js";
import { DailyReportsTable } from "../../../common/Tables/Tables.jsx";

export const Operations = () => {
  const [loading, setLoading] = useState(false);
  const [stats, setStats] = useState([]);
  const [showReportModal, setShowReportModal] = useState(false);
  const [clipboard, setClipboard] = useState({});
  const [dailyReportTable, setDailyReportTable] = useState({
    data: [],
    isLoading: false,
  });
  const user = authService.getUser();
  const userName =
    capitalize(user?.firstName) + " " + capitalize(user?.lastName);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    getValues,
    resetField,
    watch,
    setError,
    control,
  } = useForm({
    resolver: yupResolver(schemas.dailyReportSchema()),
  });

  const getStats = async (startHour, endHour) => {
    setLoading(true);
    let payload = [];
    let params = {
      //ISODate
      dateFrom: startHour
        ? new Date(startHour).toISOString()
        : new Date(moment().startOf("day")).toISOString(),
      dateTo: endHour
        ? new Date(endHour).toISOString()
        : new Date(moment().endOf("day")).toISOString(),
    };

    try {
      const response = await statisticsService.getOperationsStats(params);
      if (response.status === 200) {
        if (!startHour && !endHour) {
          setStats(response.data);
        } else {
          payload = response.data;
        }
        setLoading(false);
        return payload;
      } else {
        notify(`${response.message}` || "error", "error");
        setLoading(false);
        return [];
      }
    } catch (error) {
      notify(`${error.message}` || "error", "error");
      setLoading(false);
      return [];
    }
  };

  const getDailyReports = async () => {
    setLoading(true);
    let payload = [];
    let params = {
      date: moment().format("YYYY-MM-DD"),
      userId: user?._id,
    };

    try {
      const response = await statisticsService.getDailyReports(params);
      if (response.status === 200) {
        const res = response.data.reports.map((report) => {
          report.user = userName;
          return report;
        });
        setDailyReportTable((prevState) => {
          return {
            ...prevState,
            data: res,
            isLoading: false,
          };
        });
        setLoading(false);
        return payload;
      } else {
        notify(`${response.message}` || "error", "error");
        setLoading(false);
        return [];
      }
    } catch (error) {
      notify(`${error.message}` || "error", "error");
      setLoading(false);
      return [];
    }
  };

  const createReport = handleSubmit(async (data) => {
    const start = moment(data?.hourFrom);
    const end = moment(data?.hourTo);
    const duration = moment.duration(end.diff(start));
    const hours = duration.asHours();
    if (hours > 24) {
      notify(
        "No se puede crear un reporte con un rango mayor a 24 horas",
        "error"
      );
      return;
    }

    const actualStats = await getStats(data.hourFrom, data.hourTo);
    let activeCasesMockup = {
      active: 0,
      particular: 0,
      scheduled: 0,
      activeTowInternal: 0,
      activeTowExternal: 0,
      activeAv: 0,
      activeOperator: 0,
    };
    let doneCasesMockup = {
      done: 0,
      doneAv: 0,
      doneTow: 0,
      doneTowInternal: 0,
      doneTowExternal: 0,
      particular: 0,
      solvedAvApproved: 0,
      scheduled: 0,
    };
    const body = {
      startDate: new Date(data.hourFrom).toISOString(),
      endDate: new Date(data.hourTo).toISOString(),
      reportedErrors: data.errorCommited,
      activeCases: actualStats?.activeCases
        ? actualStats.activeCases
        : activeCasesMockup,
      doneCases: actualStats?.doneCases
        ? actualStats.doneCases
        : doneCasesMockup,
    };

    try {
      setLoading(true);
      const response = await statisticsService.createDailyReport(body);
      if (response.status === 200) {
        notify("Reporte creado correctamente", "success");
        reset();
        response.data.createdReport.user = userName;
        setClipboard(response?.data?.createdReport);
      } else {
        notify(`${response.message}` || "error", "error");
      }
      getDailyReports();
      setLoading(false);
      reset();
      return;
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  });

  const handleCloseModal = () => {
    reset();
    setClipboard({});
    setValue("errorCommited", 0);
    setShowReportModal(false);
  };

  useEffect(() => {
    getStats();
    getDailyReports();
  }, []);

  return (
    <>
      <LoadSpinner show={loading} />
      <Header />
      <DailyReportModal
        modal={showReportModal}
        handleClose={handleCloseModal}
        register={register}
        errors={errors}
        handleSubmit={handleSubmit}
        action={createReport}
        control={control}
        clipboardData={clipboard}
      />
      <div className="service-with-container container">
        <h1 className="title-component">Operación</h1>
        <div className="gray-line"></div>
        <div className="row" style={{ justifyContent: "end" }}>
          <div className="col-12 col-md-6 d-flex justify-content-end filter-buttons-container">
            <ActionButton
              label="Reporte del día"
              action={() => setShowReportModal(true)}
            />
          </div>
        </div>
        <br />
        <div className="row">
          <div className="indicators-section-container indicators-section-container-l col-12 col-md-6">
            <div className="row">
              <h2>Casos Activos</h2>
              <div className="col-12 col-lg-4">
                <OperationCard
                  src={caseOpenOperations}
                  label={"Casos abiertos"}
                  value={stats?.activeCases?.active || 0}
                />
              </div>
              <div className="col-12 col-lg-4">
                <OperationCard
                  src={caseOpenOperations}
                  label={"Casos Particulares"}
                  value={stats?.activeCases?.particular || 0}
                />
              </div>
              <div className="col-12 col-lg-4">
                <OperationCard
                  src={caseOpenOperations}
                  label={"Casos Agendados"}
                  value={stats?.activeCases?.scheduled || 0}
                />
              </div>
              <div className="col-12 col-lg-4">
                <OperationCard
                  src={craneIndicator}
                  label={"Gruas Propias Operando"}
                  value={stats?.activeCases?.activeTowInternal || 0}
                />
              </div>
              <div className="col-12 col-lg-4">
                <OperationCard
                  src={craneIndicator}
                  label={"Gruas Externas Operando"}
                  value={stats?.activeCases?.activeTowExternal || 0}
                />
              </div>
              <div className="col-12 col-lg-4">
                <OperationCard
                  src={bikeOrange}
                  label={"Motorizados operando"}
                  value={stats?.activeCases?.activeAv || 0}
                />
              </div>
              <div className="col-12 col-lg-4">
                <OperationCard
                  src={operatorStats}
                  label={"Operadores Activos"}
                  value={stats?.activeCases?.activeAv || 0}
                />
              </div>
            </div>
          </div>
          <div className="indicators-section-container indicators-section-container-r  col-12 col-md-6">
            <h2>Casos Finalizados</h2>
            <div className="row">
              <div className="col-12 col-lg-4">
                <OperationCard
                  src={finishedOperator}
                  label={"Casos Finalizados"}
                  value={stats?.doneCases?.done || 0}
                />
              </div>
              <div className="col-12 col-lg-4">
                <OperationCard
                  src={bikeOrange}
                  label={"AV Realizados"}
                  value={stats.doneCases?.doneAv || 0}
                />
              </div>
              <div className="col-12 col-lg-4">
                <OperationCard
                  src={toedOperator}
                  label={"Remolques Realizados"}
                  value={stats?.doneCases?.doneTow || 0}
                />
              </div>
              <div className="col-12 col-lg-4">
                <OperationCard
                  src={fixOperator}
                  label={"Averías Resueltas"}
                  value={stats?.doneCases?.solvedAvApproved || 0}
                />
              </div>
              <div className="col-12 col-lg-4">
                <OperationCard
                  src={craneIndicator}
                  label={"Servicios de grúas propias"}
                  value={stats?.doneCases?.doneTowInternal || 0}
                />
              </div>{" "}
              <div className="col-12 col-lg-4">
                <OperationCard
                  src={craneIndicator}
                  label={"Servicios de grúas Externas"}
                  value={stats?.doneCases?.doneTowExternal || 0}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          margin: "1%",
          marginTop: "2%",
          marginBottom: 0,
        }}
      >
        <h3 className="title-component">Reportes</h3>
        <DailyReportsTable
          header={DailyReportTableHeader}
          data={dailyReportTable}
        />
      </div>
    </>
  );
};
